import {
  AssessmentBase,
  AssessmentWithEntries,
  DATE_FORMAT_SHORT_FNS,
  EvaluationType,
  FilterKeys,
  GroupType,
} from '@schooly/api';
import { AssessmentsArrangeBy } from '@schooly/components/filters';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { format } from 'date-fns';
import { useIntl } from 'react-intl';

export const useAssessmentLabels = () => {
  const { formatMessage } = useIntl();

  const getAssessmentEvaluationTitle = <
    T extends Pick<AssessmentBase, 'evaluation_type' | 'name' | 'area_of_learning'>,
  >(
    assessment: T,
  ) => {
    switch (assessment.evaluation_type) {
      case EvaluationType.AreaOfLearning:
        return assessment.area_of_learning?.name;
      case EvaluationType.TutorFeedback:
        return formatMessage({ id: 'assessments-TutorsFeedback' });
    }
  };

  const getAssessmentsArrangeByTitle = (
    arrangeBy: AssessmentsArrangeBy,
    assessment: AssessmentWithEntries,
  ) => {
    const {
      assessment_date: date,
      groups: [group],
    } = assessment;

    const { type: groupType, subject } = group ?? {};

    switch (arrangeBy) {
      case FilterKeys.Date:
        return format(newDateTimezoneOffset(date), DATE_FORMAT_SHORT_FNS).toUpperCase();

      case FilterKeys.Subject:
        const isTutorGroup = groupType === GroupType.TutorGroup;
        const subjectName = subject?.name ?? '';
        return isTutorGroup ? formatMessage({ id: 'groups-TutorGroup' }) : subjectName;

      case FilterKeys.AreaOfLearning:
        return (
          getAssessmentEvaluationTitle(assessment) ??
          formatMessage({ id: 'assessments-OtherAssessments' })
        );
    }
  };

  return { getAssessmentEvaluationTitle, getAssessmentsArrangeByTitle };
};
